import React from 'react';
import { func, number } from 'prop-types';

class AuctionsWrap extends React.Component {
  componentWillUnmount() {
    this.props.clearAuctions();
  }

  setGridPage = pageNo =>
    pageNo !== this.props.pageNo && this.props.setGridPage(pageNo);

  getChildContext() {
    return {
      pageNo: this.props.pageNo,
      setGridPage: this.setGridPage,
    };
  }

  render() {
    return <div>{this.props.children}</div>;
  }
}

AuctionsWrap.childContextTypes = {
  setGridPage: func,
  pageNo: number,
};

export default AuctionsWrap;
